<mat-dialog-content>
    <title mat-dialog-title>{{ playerGroup.controls.nameControl.value }}</title>
    <mat-card-content>
        <form [formGroup]="playerGroup">
            <div class="picture-preview-container square">
                <img [src]="playerGroup.controls.pictureControl.value || placeholderPersonImage">
            </div>
            <input type="file" accept="image/png, image/jpeg" #logoInput hidden (change)="uploadPicture($event)">
            <button class="upload-button" tabindex="-1" mat-raised-button type="button" *ngIf="pictureUploadProgress == 0 && !playerGroup.controls.pictureControl.value" (click)="logoInput.click()" color="accent"><mat-icon>upload</mat-icon>Upload</button>
            <button class="upload-button" tabindex="-1" mat-raised-button type="button" *ngIf="pictureUploadProgress == 0 && playerGroup.controls.pictureControl.value" (click)="logoInput.click()" color="accent"><mat-icon>upload</mat-icon>Replace</button>
            <button class="upload-button" tabindex="-1" mat-raised-button type="button" *ngIf="pictureUploadProgress > 0" disabled><mat-progress-spinner mode="determinate" value="{{ pictureUploadProgress }}"></mat-progress-spinner></button>
            <button class="delete-button-img" tabindex="-1" mat-raised-button *ngIf="playerGroup.controls.pictureControl.value && !isProcessingPictureDelete" (click)="deletePicture(false)" color="warn"><mat-icon>delete_outline</mat-icon>Delete</button>
            <button class="delete-button-img" tabindex="-1" mat-raised-button *ngIf="!playerGroup.controls.pictureControl.value && !isProcessingPictureDelete" disabled><mat-icon>delete_outline</mat-icon>Delete</button>
            <button class="delete-button-img" tabindex="-1" mat-raised-button *ngIf="isProcessingPictureDelete" disabled><mat-spinner></mat-spinner></button>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Name</mat-label>
                <input matInput [formControl]="playerGroup.controls.nameControl" (input)="changeName()">
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Nationality</mat-label>
                <mat-select [formControl]="playerGroup.controls.nationalityControl" (selectionChange)="changeNationality()">
                    <mat-select-trigger>
                        <ng-container *ngIf="getSelectedNationality(playerGroup.controls.nationalityControl.value) as nationality">
                            <img class="select-field-logo" [src]="'https://assets.liumex.com/resources/esportsms/content/f/' + nationality.code + '.svg' || placeholderImage"> {{ nationality.name }}
                        </ng-container>
                    </mat-select-trigger>
                    <ng-container *ngFor="let nationality of nationalities">
                        <mat-option [value]="nationality.code">
                            <img class="select-field-logo" [src]="'https://assets.liumex.com/resources/esportsms/content/f/' + nationality.code + '.svg' || placeholderImage"> {{ nationality.name }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Languages</mat-label>
                <mat-select [formControl]="playerGroup.controls.languagesControl" (selectionChange)="changeLanguages()" multiple>
                    <mat-option *ngFor="let language of languages" [value]="language.code">{{ language.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Seat Position</mat-label>
                <mat-select [formControl]="playerGroup.controls.positionControl" (selectionChange)="changePosition()">
                    <mat-option [value]="1">1</mat-option>
                    <mat-option [value]="2">2</mat-option>
                    <mat-option [value]="3">3</mat-option>
                    <mat-option [value]="4">4</mat-option>
                    <mat-option [value]="5">5</mat-option>
                    <mat-option [value]="6">Substitute</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Armrest</mat-label>
                <mat-select [formControl]="playerGroup.controls.armrestControl" (selectionChange)="changeArmrest()">
                    <mat-option [value]="true">On</mat-option>
                    <mat-option [value]="false">Off</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Pillow</mat-label>
                <mat-select [formControl]="playerGroup.controls.pillowControl" (selectionChange)="changePillow()">
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>In-Ears</mat-label>
                <mat-select [formControl]="playerGroup.controls.inearsControl" (selectionChange)="changeInEars()">
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Notes</mat-label>
                <textarea matInput [formControl]="playerGroup.controls.notesControl" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="10" (input)="changeNotes()"></textarea>
            </mat-form-field>
        </form>
    </mat-card-content>
</mat-dialog-content> 